import React, { useEffect, useRef, useState } from 'react'
import { FaQuestionCircle } from 'react-icons/fa'

const FAQ_DATA = [
  {
    question: 'What can we do for you with Figma?',
    answer: 'Fusce eu eros nec felis venenatis fermentum sit amet eget turpis. Integer tempus massa ac arcu sollicitudin.'
  },
  {
    question: 'What is the standard size of business cards?',
    answer: 'Integer tempus massa ac arcu sollicitudin sollicitudin Vivamus neque urna, iaculis et orci id, euismod tempor arcu.'
  },
  {
    question: 'How does your design process work?',
    answer: 'Euismod tempor arcu semper congue nulla amet finibus. Vivamus neque urna, iaculis et orci id, fermentum sit amet eget turpis.'
  },
  {
    question: 'Do you offer support after the project is finished?',
    answer: 'Fusce eu eros nec felis venenatis fermentum sit amet eget turpis. Integer tempus massa ac arcu sollicitudin.'
  },
]

const FAQSection = ({ }) => {

  const [openItem, setOpenItem] = useState(null)

  const toggleItem = (index) => {
    if (openItem === index) {
      setOpenItem(null)
    } else {
      setOpenItem(index)
    }
  }

  const contentRefs = useRef([])

  useEffect(() => {
    contentRefs.current = contentRefs.current.slice(0, FAQ_DATA.length);
  }, [FAQ_DATA.length])

  return (
    <section className='faq-one'>
      <div className="container mx-auto px-4 py-8">
        <div className="flex flex-wrap -mx-4">
          {/* Image Section */}
          <div className="w-full lg:w-2/5 xl:w-1/2 animate__animated animate__fadeInLeft" style={{ animationDelay: '0.1s', animationDuration: '1500ms' }}>
            <div className="relative mb-4">
              <img src="https://source.unsplash.com/random/300x200" alt="faq" className="rounded-lg shadow-lg" />
              <img src="https://source.unsplash.com/random/300x200?2" alt="faq" className="rounded-lg shadow-lg absolute top-0 right-0 mt-12 mr-12" />
              {/* Additional shapes or SVG elements can be added here */}
            </div>
          </div>

          {/* Text and Accordion Section */}
          <div className="w-full lg:w-3/5 xl:w-1/2">
            <div className="px-4">
              {/* <div className="flex items-center mb-4">
                <img src="https://source.unsplash.com/random/50x50" alt="top-title-logo" className="mr-2" />
                <p className="text-lg font-semibold">Our Frequency</p>
              </div> */}
              <h2 className="text-4xl font-bold mb-4 animate__animated animate__fadeInUp" style={{ animationDuration: '1500ms' }}>
                We provide advanced frequency and questions
              </h2>
              <p className="mb-8">Proin id pulvinar massa. Nam tristique eleifend nullam felis risus facilisis estlis pellentesque. Fusce eu eros nec felis venenatis fermentum.</p>

              <div className="space-y-0 text-2xl">
                {FAQ_DATA.map((faq, index) => (
                  <div key={index} className="faq-item flex flex-row border p-4 rounded-lg transition-all duration-500 ease-in-out cursor-pointer" onClick={() => toggleItem(index)}>
                    <div className='mr-4 mt-1'>
                      <FaQuestionCircle />
                    </div>
                    <div>
                      <div
                        className="font-semibold w-full text-left"
                      >
                        {faq.question}
                      </div>
                      <div
                        ref={el => contentRefs.current[index] = el}
                        className="transition-all duration-500 ease-in-out overflow-hidden"
                        style={{
                          maxHeight: openItem === index ? `${contentRefs.current[index]?.scrollHeight}px` : '0',
                        }}
                      >
                        <p className="py-2">{faq.answer}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FAQSection
